// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import { isMobileResolution } from '../../infrastructure/utils/common';
import CollapsableItem from '../utils/CollapsableItem';
import { StyledMobileBoxItemRow } from '../utils/Styles/DataBoxStyles';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const ActivityVendorMobile = ({ activity }) => {
  if (!isMobileResolution()) return null;
  return (
    <div className='data-box'>
      <h4 className='header'>Vendor</h4>
      <CollapsableItem>
        <StyledMobileBoxItemRow maxWidth='100%'>
          Name:
          {/* TODO: Fix this the next time the file is edited. */}
          {/* eslint-disable-next-line react/prop-types */}
          <span>{activity.vendorName}</span>
        </StyledMobileBoxItemRow>
        <StyledMobileBoxItemRow maxWidth='100%'>
          About:
          {/* TODO: Fix this the next time the file is edited. */}
          {/* eslint-disable-next-line react/prop-types */}
          <span dangerouslySetInnerHTML={{ __html: activity.description }} />
        </StyledMobileBoxItemRow>
      </CollapsableItem>
    </div>
  );
};

export default ActivityVendorMobile;
